import { InvalidScopeError } from '@tokamakjs/injection';
import { useContext } from 'react';
import { InvalidControllerDependencyError, NoDecoratedControllerError } from '../errors';
import { ControllerContext } from '../routing';
import { isDecoratedController } from '../types';
import { useDiContainer } from './use-di-container';
import { useHooksContainer } from './use-hooks-container';
export function useController() {
  var ctrl = useContext(ControllerContext);

  if (ctrl == null) {
    throw new Error('Controller not found.');
  }

  return ctrl;
}
export function useResolveController(Controller) {
  var container = useDiContainer();

  try {
    var instance = container.resolveDepsSync(Controller);

    if (!isDecoratedController(instance)) {
      throw new NoDecoratedControllerError(Controller.name);
    }

    return useHooksContainer(instance);
  } catch (err) {
    if (err instanceof InvalidScopeError) {
      throw new InvalidControllerDependencyError(Controller.name);
    }

    throw err;
  }
}